import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadSystemEventsFailed, loadSystemEventsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';
import { clearEmptyProp } from '../../../utils/utils';
import addSortQuery from '../../../utils/addSortQuery';

export default function* loadSystemEvents(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      offset = 0,
      filter,
      reverse = false,
      sortedColumns = [],
    } = payload;
    let pool = {
      limit,
      offset,
      reverse,
    };
    yield delay(200);
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = { ...clearEmptyProp(filter), ...pool };
      // pool = { ...filter, ...pool };
    }
    if (sortedColumns && Array.isArray(sortedColumns)) {
      pool = addSortQuery(sortedColumns, pool);
    }
    const url = `${BACKEND_URL}/api/v1/system-logs`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data) {
      yield put(loadSystemEventsSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadSystemEventsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadSystemEventsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
